"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/label-has-for */
/** @jsx jsx */
const defaults_1 = require("@clearsummit/summithill-models/lib/defaults");
const core_1 = require("@emotion/core");
const constants_1 = __importStar(require("@/constants"));
const styles_1 = __importDefault(require("./styles"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const SessionItem = ({ index, onClick, sessionType, active, completed, }) => (core_1.jsx("div", { onClick: onClick, role: "button", tabIndex: index, "aria-label": "Process session Item", onKeyPress: e => {
        if (e.key === 'Enter') {
            onClick();
        }
    }, className: styles_scss_1.default.sessionItem, css: styles_1.default.sessionItem(active) },
    core_1.jsx("div", { className: styles_scss_1.default.sessionItemLeftCont },
        core_1.jsx("img", { className: styles_scss_1.default.calendarIcon, src: active || completed ? constants_1.Images.calendarIconActive : constants_1.Images.calendarIcon, alt: "calendar icon" })),
    core_1.jsx("div", { className: styles_scss_1.default.sessionItemCenterCont },
        core_1.jsx("label", { css: styles_1.default.sessionItemLabel(active) }, constants_1.default.program.bookSessionType[defaults_1.snakeToCamel(sessionType)])),
    core_1.jsx("div", { className: styles_scss_1.default.sessionItemRightCont }, !active && (core_1.jsx("img", { css: styles_1.default.rightIcon(completed), src: completed ? constants_1.Images.check : constants_1.Images.lock, alt: completed ? 'check' : 'lock' })))));
exports.default = SessionItem;
